import React from 'react'
import { FormattedMessage } from 'react-intl'
import 'normalize.css'
import { NavHashLink as NavLink } from 'react-router-hash-link'

import Header from './components/Header'
import Footer from './components/Footer'

class Error404 extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    render() {
        return (
            <main className="main">
                <Header />
                <section className="intro error404" id="start">
                    <div className="error404__wrapper wrapper">
                        <h1 className="intro__title">
                            <strong className="intro__title__strong">
                                <FormattedMessage id="error404" defaultMessage="Error 404" />
                            </strong>
                            {' - '}
                            <span className="intro__title__span">
                                <FormattedMessage id="page_not_found" defaultMessage="Página no encontrada" />
                            </span>
                        </h1>
                        <div className="error404__wrapper__go_home">
                            <NavLink
                                to="/"
                                scroll={el =>
                                    el.scrollIntoView({
                                        behavior: 'smooth',
                                        block: 'start',
                                        inline: 'start'
                                    })
                                }
                                className={'error404__wrapper__go_home'}
                            >
                                <FormattedMessage id="go_home" defaultMessage="Ir a inicio" />
                            </NavLink>
                        </div>
                    </div>
                </section>

                <Footer />
            </main>
        )
    }
}

export default Error404



// WEBPACK FOOTER //
// ./src/Error404.js